<template>
  <div class="page_box" v-if="showBox == 'list'">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="addClick"
        >
          新增
        </el-button>
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-chat-line-square"
          :disabled="ids.length == 0"
          @click="flagState"
        >
          标记已读
        </el-button>
        <el-button
          type="danger"
          size="mini"
          plain
          icon="el-icon-circle-close"
          :disabled="ids.length == 0"
          @click="deleteClick(ids)"
        >
          删除
        </el-button>
      </div>
      <div class="search_box">
        <el-select
          v-model="requestData.announcementClassification"
          size="mini"
          clearable
        >
          <el-option label="上级分发" :value="1"></el-option>
          <el-option label="本单位发布" :value="0"></el-option> </el-select
        >&nbsp;
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="getList"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectActionData"
        >
          <el-table-column type="selection" width="70" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="publisher"
            label="发送人"
            width="200"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="notificationTitle"
            label="标题"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link type="primary" @click="checkInfo(scope.row.id)">{{
                scope.row.notificationTitle
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="date1"
            label="发送时间"
            width="180"
            align="center"
          >
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.releaseTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="name1" label="状态" width="120" align="center">
            <template slot-scope="rowData">
              <el-tag
                v-if="rowData.row.announcementStatus == 0"
                type="warning"
                effect="plain"
                size="small"
              >
                <i class="el-icon-message"></i>
                未读
              </el-tag>

              <el-tag
                v-if="rowData.row.announcementStatus == 1"
                type="success"
                effect="plain"
                size="small"
              >
                <i class="el-icon-chat-dot-square"></i>
                已读
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="checkInfo(scope.row.id)"
                >查看详情</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="deleteClick([scope.row.id])"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
  <improving-notice-add v-else-if="showBox == 'add'" @goBack="addGoBack">
  </improving-notice-add>
  <improving-notice-info
    v-else
    :id="rowID"
    @goBack="infoGoBack"
  ></improving-notice-info>
</template>

<script>
import NoticeTop from "@/components/NoticeTop";
import ImprovingNoticeAdd from "./components/ImprovingNoticeAdd.vue";
import ImprovingNoticeInfo from "./components/ImprovingNoticeInfo.vue";
export default {
  name: "",
  components: { NoticeTop, ImprovingNoticeAdd, ImprovingNoticeInfo },
  props: {},
  data() {
    return {
      showBox: "list",
      requestData: {
        schoolId: this.$store.state.schoolId,
        announcementClassification: "",
        pageSize: 20,
        pageNum: 1
      },
      tableData: [],
      total: 0,
      ids: [],
      rowID: ""
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.requestData.pageNum = val;
      this.getList();
    },
    async getList() {
      let res = await this.$Http.getAnnouncementList(this.requestData);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          type: "error",
          message: "列表获取失败"
        });
      }
    },
    selectActionData(selectData) {
      this.ids = selectData.map((item) => {
        return item.id;
      });
    },
    addClick() {
      this.showBox = "add";
    },
    addGoBack(type) {
      this.showBox = "list";
      if (type) {
        this.getList();
      }
    },
    // 标记已读
    async flagState() {
      let req = {
        id: this.ids
      };
      let res = await this.$Http.mailStatus(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "标记成功"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: "标记失败"
        });
      }
    },
    // 删除公告
    deleteClick(data) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteInfo(data);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteInfo(data) {
      let res = await this.$Http.deleteAnnouncements({ noticeId: data });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: "删除失败"
        });
      }
    },
    checkInfo(id) {
      this.rowID = id;
      this.showBox = "info";
    },
    infoGoBack() {
      this.showBox = "list";
    }
  },
  created() {},
  mounted() {
    this.getList();
  }
};
</script>
<style scoped></style>
